import React from 'react';
import { Link } from 'react-router-dom';

import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';

const EditButton = ({
  id,
  parentId,
  disabled,
  onClick
}: {
  id: string;
  parentId?: string;
  disabled?: boolean;
  onClick?: () => void;
}) => {
  const isChild = !!parentId;
  const finalRoute = isChild
    ? `/producer/product/editproduct/${parentId}/${id}`
    : `/producer/product/editproduct/${id}`;

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <PermissionHide action='myeduzz:meus-produtos:editar'>
      <Link to={finalRoute}>
        <Button
          id='quickview-product-edit-button'
          size='small'
          onClick={handleClick}
          type='text'
          style={{
            color: disabled ? '#ddd' : '#596375',
            fontSize: 12,
            fontWeight: 600
          }}
          disabled={disabled}
          icon={<EditOutlined style={{ fontSize: 12, color: '#596375' }} />}
        >
          Editar
        </Button>
      </Link>
    </PermissionHide>
  );
};

export default EditButton;
